import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { apiErrorMessage } from '../../../api/http';
import { FormError, ModalActions } from '../modalStyles';

interface ConfirmarEliminarModalProps {
	open: boolean;
	label: 'anuncio' | 'evento';
	nombre: string;
	onConfirm: () => void | Promise<void>;
	onCancel: () => void;
}

const ConfirmarEliminarModal: React.FC<ConfirmarEliminarModalProps> = ({
	open,
	label,
	nombre,
	onConfirm,
	onCancel,
}) => {
	const [error, setError] = useState<string | null>(null);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (!open) return;
		setError(null);
		setSaving(false);
	}, [open]);

	const handleConfirm = async () => {
		if (saving) return;
		setSaving(true);
		setError(null);
		try {
			await onConfirm();
		} catch (err) {
			setError(apiErrorMessage(err));
			setSaving(false);
		}
	};

	const handleCancel = () => {
		if (saving) return;
		onCancel();
	};

	return (
		<Dialog open={open} onClose={handleCancel} maxWidth='xs' fullWidth>
			<DialogTitle>Eliminar {label}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					¿Estás seguro de que deseas eliminar el {label} <strong>{nombre}</strong>?
				</DialogContentText>
				{error && <FormError severity='error'>{error}</FormError>}
			</DialogContent>
			<ModalActions>
				<Button variant='outlined' onClick={handleCancel} disabled={saving}>
					Cancelar
				</Button>
				<Button variant='contained' color='error' onClick={() => void handleConfirm()} disabled={saving}>
					{saving ? 'Eliminando...' : 'Eliminar'}
				</Button>
			</ModalActions>
		</Dialog>
	);
};

export default ConfirmarEliminarModal;
